// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp')
  , defined  = require('./_defined');

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_string-context.js
 ** module id = 141
 ** module chunks = 1
 **/